export default "__VITE_ASSET__BzRWtyrT__"